export const getSearchPageLoadKey = (options: {
  query: string;
  filters: string[];
  pageNumber: number;
  doQuerySpellCheck: boolean;
  noBrandsOffFaireQuery: boolean;
}) => {
  const {
    query,
    filters,
    pageNumber,
    doQuerySpellCheck,
    noBrandsOffFaireQuery,
  } = options;
  return `${query}-${filters}-${pageNumber}-${doQuerySpellCheck}-${noBrandsOffFaireQuery}`;
};
